dojo.addOnLoad(function() {
	var searchTermInputField = document.getElementById('SimpleSearchForm_SearchTerm');
	if (searchTermInputField) {
		var omnitureEnabled = '';
		if(null != $('#omnitureEnabled') && undefined != $('#omnitureEnabled')) {    
        	omnitureEnabled = $('#omnitureEnabled').val();
    	}
		if(omnitureEnabled != 'true'){
			var searchKeyword = document.getElementById('SimpleSearchForm_SearchTerm').value;
			utag_data["search_keyword"] = searchKeyword;
		}
		document.getElementById('SimpleSearchForm_SearchTerm').onkeyup = function() {lookAheadFunction()};
		function lookAheadFunction() {
	    	var searchValueLength = document.getElementById('SimpleSearchForm_SearchTerm').value.length;
			var searchValue = document.getElementById('SimpleSearchForm_SearchTerm').value;
			var autoSuggest_Result_div = document.getElementById("autoSuggest_Result_div");
			if(searchValueLength > 2 && autoSuggest_Result_div != null && autoSuggest_Result_div != 'undefined' && autoSuggest_Result_div.style.display == 'block') {
				document.getElementById("look-ahead").classList.add("active");
			} else {
				document.getElementById("look-ahead").classList.remove("active");
			}
		}
	}
});
